var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isReleasePage)?_c('ReleasePage'):_c('div',{staticClass:"container release-app inner-app"},[(_vm.isLoading)?_c('Loader',{attrs:{"fullScreen":true}}):_c('div',{staticClass:"inner-app-content",domProps:{"innerHTML":_vm._s(_vm.loadedHtml)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }